angular.module("app").controller("PageBuilderController", [
    '$scope',
    '$cookies',
    '$window',
    '$templateRequest',
    '$interpolate',
    '$timeout',
    '$uibModal',
    'preloadedProviders',
    'service',
    'errorHandler',
    'logger',
    'settingsService',
    'preloadedProperties',
    'deepCompare',
    'casinoGameService',
    'backgroundAttachment',
    'builderPageDefaults',
    'Utils',
    function ($scope, $cookies, $window, $templateRequest, $interpolate, $timeout, $modal, preloadedProviders, service, errorHandler, logger, settingsService,  preloadedProperties, deepCompare, casinoGameService, backgroundAttachment, builderPageDefaults, Utils) {
        var settings = settingsService.getSettings();
        var init;
        $scope.backgroundAttachment = backgroundAttachment;
        $scope.mediaFilters = {
            device: "desktop"
        };
        if (preloadedProviders) {
            $scope.providers = preloadedProviders.map(function (item) {
                var key = item.providerTitle + " (" + item.provider +  ")";
                return {Name: key, Id: item.provider};
            });
            $scope.mediaFilters.selectedProviders = preloadedProviders.map(function (item) {
                return item.provider;
            });
        }

        $scope.gamesContainer = {filter: ""};
        $scope.gamesContainer.games = [];
        $scope.stateOfBuilder = "media";
        var reversedBackgroundSize = Utils.createReverse(builderPageDefaults.backgroundSize);
        var allGames;


        /**
         * Load games data
         */
        $scope.loadGames = function loadGames() {

            if (preloadedProviders && !$scope.mediaFilters.selectedProviders.length ) {
                $scope.gamesContainer.games = allGames = [];
                return;
            }

            var requestOptions = {
                is_mobile: $scope.mediaFilters.device === 'mobile'? 1: 0,
                categories: [preloadedProviders? "28": "36"],
                active: true
            };
            if (preloadedProviders) {
                requestOptions.providers = $scope.mediaFilters.selectedProviders;
            }
            casinoGameService.getSkinGames(requestOptions).then(function (response) {
                    if (response.status === "ok") {
                        allGames = angular.copy(response.skinGames);
                        allGames.forEach(function (value) {
                            $scope.page.media.gameIdImageMap[value.gameSkinId ] = $scope.page.media.gameIdImageMap[value.gameSkinId ] || {};
                        });
                        $scope.filterGames();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                });
        };

        (init = function (data) {
            $scope.page = {};
            initBackgrounds(data['background_properties']);
            if (preloadedProviders) {
                initGrids(data['grid_properties']);
            }
            initMedia(data['media_properties']);
            if (!data['background_properties'] && !data['grid_properties'] && !data['media_properties']) {
                $scope.isAvailableForPublish = true;
            } else {
                $scope.isAvailableForPublish = false;
            }
            $scope.initialData = angular.copy($scope.page);
        })(preloadedProperties);

        function initBackgrounds(backgroundProperties, language){
            $scope.imageToLoad = undefined;
            $scope.calledCount = 0;

            $scope.draggedImageDataUrl = $scope.draggedImage = $scope.cropped = undefined;
            if (backgroundProperties) {
                if (language) {
                    $scope.publishAllBackgrounds = false;
                }
                $scope.page.background = {};
                var background = $scope.page.background;
                if (backgroundProperties.image) {
                    background.image = backgroundProperties.image;
                    $scope.initialBackgroundImage = backgroundProperties.image;
                } else {
                    $scope.initialBackgroundImage = undefined;
                }
                background.selectedLanguage = backgroundProperties.lang || language || $cookies.get("preferedLanguage") || settings.skin.defaultLang;
                background.isActive = backgroundProperties.status === 'published';
                if (backgroundProperties.options) {
                    background.customSizeType = 'px';
                    background.size = {};
                    if (reversedBackgroundSize[backgroundProperties.options['size']]) {
                        background.size.type = reversedBackgroundSize[backgroundProperties.options['size']];
                    } else {
                        background.size.type = 'custom';
                        if (backgroundProperties.options['size'] && backgroundProperties.options['size'].indexOf('%') > -1) {
                            background.customSizeType = '%';
                        }
                        background.size.size = backgroundProperties.options['size'].replace('%', '').replace('px', '');
                    }
                    extractPosition(backgroundProperties.options.position);
                    background.attachment = backgroundProperties.options.attachment || $scope.backgroundAttachment[0];
                    background.color = backgroundProperties.options.color || builderPageDefaults.color;
                    background.isColorEditable = $scope.page.background.color !== 'transparent';
                } else {
                    background.color = builderPageDefaults.color;
                    background.attachment = $scope.backgroundAttachment[0];
                    background.size = {
                        type:  builderPageDefaults.defaultBackgroundSizeType
                    };
                    $scope.page.background = Object.assign({}, background, {
                        customSizeType: 'px',
                        positionHorizontalRadio: 'left',
                        positionVerticalRadio: 'top',
                        positionCustom: false,
                        positionHorizontal: "",
                        positionVertical: "",
                        customPositionType: 'px',
                        isColorEditable: false
                    })
                }
            } else {
                if (language) {
                    $scope.publishAllBackgrounds = true;
                }
                $scope.page.background = {
                    image: "",
                    selectedLanguage: language || $cookies.get("preferedLanguage") || settings.skin.defaultLang,
                    color: builderPageDefaults.color,
                    attachment: $scope.backgroundAttachment[0],
                    size: {
                        type:  builderPageDefaults.defaultBackgroundSizeType
                    },
                    customSizeType: 'px',
                    positionHorizontalRadio: 'left',
                    positionVerticalRadio: 'top',
                    positionCustom: false,
                    positionHorizontal: "",
                    positionVertical: "",
                    customPositionType: 'px',
                    isColorEditable: false
                }
            }
            if($scope.initialData) {
                $scope.initialData.background = angular.copy($scope.page.background);
            }

        }


        $scope.$watch('page.background.positionCustom', function (newValue) {
            if (!$scope.page.background) {
                return;
            }
            if(newValue) {
                $scope.page.background.positionHorizontalRadio = "";
                $scope.page.background.positionVerticalRadio = "";
            }
        });

        $scope.$watch('page.background.positionHorizontalRadio', function () {
            if (!$scope.page.background) {
                return;
            }
            if ($scope.page.background.positionCustom && $scope.page.background.positionHorizontalRadio)  {
                $scope.page.background.positionCustom = false;
                $scope.page.background.positionVerticalRadio = 'top';
                $scope.page.background.positionVertical = "";
                $scope.page.background.positionHorizontal = "";
            }
        });

        $scope.$watch('page.background.positionVerticalRadio', function () {
            if (!$scope.page.background) {
                return;
            }
            if ($scope.page.background.positionCustom && $scope.page.background.positionVerticalRadio)  {
                $scope.page.background.positionCustom = false;
                $scope.page.background.positionHorizontalRadio = 'left';
                $scope.page.background.positionVertical = "";
                $scope.page.background.positionHorizontal = "";
            }
        });

        $scope.adjustColor = function adjustColor() {
            $scope.page.background.color = $scope.page.background.isColorEditable? '#000000': 'transparent';
        };

        $scope.load = function (dataUrl) {
            $scope.page.background.image = dataUrl;
            $timeout(function () {
                $scope.$apply();
            });
        };

        $scope.$on("image:uploaded", function () {
            $scope.imageToLoad = null;
        });

        /**
         * Init grids data
         * @param data
         */
        function initGrids(data){
            if (data) {
                $scope.page.grid = {
                    columnQuantity: +data['g_columns'] || builderPageDefaults.columnQuantity,
                    gamesContainerType: data['g_container'] || builderPageDefaults.gridContainerType,
                    gamesContainerGaps: data['g_container_gaps'] || builderPageDefaults.gridGaps,
                    gameAlignment: data['g_align'] || builderPageDefaults.align
                }
                if (preloadedProviders) {
                    $scope.page.grid.bannerContainerType = data['b_container'] || builderPageDefaults.gridContainerType;
                }
            } else {
                $scope.page.grid = {
                    columnQuantity: builderPageDefaults.columnQuantity,
                    gamesContainerType: builderPageDefaults.gridContainerType,
                    gamesContainerGaps: builderPageDefaults.gridGaps,
                    gameAlignment: builderPageDefaults.align
                };

                if (preloadedProviders) {
                    $scope.page.grid.bannerContainerType = builderPageDefaults.gridContainerType;
                }
            }
        }


        function initMedia(data){
            if (data) {
                $scope.page.media = {};
                if (preloadedProviders) {
                    $scope.page.media.isImages = data['image_type'] === 'images';
                }
                $scope.page.media.gameIdImageMap = {};
                $scope.page.media.labels = {};
                $scope.removedGameImages = {};
            }else {
                $scope.page.media = {};
                if (preloadedProviders) {
                    $scope.page.media.isImages = false;
                }
                $scope.page.media.gameIdImageMap = {};
                $scope.page.media.labels = {};

                $scope.removedGameImages = {};

            }
            if (!preloadedProviders) {
                $scope.loadGames();
            }
        }



        $scope.languages = settings.skin.languages;
        $scope.generateArray = function generateArray(number){
            var result = [];
            for(var i = 0; i < number; ++i){
                result.push(i);
            }
            return result;
        };

        /**
         * Create request data for sending backend
         */
        function createRequestData(page, imageToLoad, dataUrl, draggedImageDataUrl){

            var requestData = {};
            requestData["background_properties"] = {
                "lang": page.background.selectedLanguage,
                "status": page.background.isActive? 'published': 'archive',
                "options": {
                    "size": $scope.getBackgroundSize(page),
                    "position": getPosition(page),
                    "attachment": page.background.attachment,
                    "color": page.background.color
                }
            };
            if (preloadedProviders) {
                requestData["grid_properties"] = {
                    "g_columns": parseInt(page.grid.columnQuantity),
                    "g_container": page.grid.gamesContainerType,
                    "g_container_gaps": page.grid.gamesContainerGaps,
                    "g_align": page.grid.gameAlignment
                };
                if (preloadedProviders) {
                    requestData["grid_properties"]['b_container'] = page.grid.bannerContainerType;
                }
            }


            if (!!imageToLoad && !!imageToLoad.fileUrl) {
                requestData["background_properties"]['media'] = {media_id: imageToLoad.id};
            } else if (dataUrl && dataUrl.indexOf('data:image') > -1) {
                requestData["background_properties"]['media'] = {image:  dataUrl};
            }else if(draggedImageDataUrl === undefined) {
                if($scope.initialBackgroundImage && !dataUrl) {
                    requestData["background_properties"]['media'] = {image: false};
                }
            }
            requestData['media_properties'] = {};
            if (preloadedProviders) {
                requestData['media_properties']['image_type'] = page.media.isImages? 'images': 'icons';
            }
            if(page.media.isImages || !preloadedProviders) {
                requestData['media_properties']['images'] = {};
                requestData['media_properties'].badges = page.media.labels;

                for (var key in page.media.gameIdImageMap) {
                    if (page.media.gameIdImageMap.hasOwnProperty(key) && Object.keys(page.media.gameIdImageMap[key]).length > 0) {
                        var item = page.media.gameIdImageMap[key];
                        var value;
                        if (item.media) {
                            value = item.media.id;
                        } else if (!item.image) {
                            if ($scope.removedGameImages[key]) {
                                value = false;
                            }
                        } else if (item.image.indexOf('data:image') > -1) {
                            value = item.image;
                        }
                        if (value !== undefined) {
                            requestData['media_properties']['images'][key] = value;
                        }
                    }
                }
            }
            return requestData;
        }


        $scope.publish = function publish() {
            if (!$scope.live_casino_form.$valid) {
                return;
            } else if(!$scope.isChanged()) {
                logger.logError("global.no_changes");
                return;
            }

            var initialRequestData = createRequestData($scope.initialData, undefined, undefined, false);
            var currentData = createRequestData($scope.page, $scope.imageToLoad, $scope.page.background.image, $scope.draggedImageDataUrl);
            var changes = deepCompare.getChanges(initialRequestData, currentData) || deepCompare.getChanges(currentData, initialRequestData) || {};
            if ($scope.publishAllBackgrounds) {
                changes['background_properties'] = currentData['background_properties'];
            } else if (changes['background_properties'] && changes['background_properties'].options) {
                changes['background_properties'].options = currentData['background_properties'].options;
            }

            if (changes['media_properties'] && changes['media_properties'].images) {
                changes['media_properties'].images = currentData['media_properties'].images;
            }

            if (changes['media_properties'] && changes['media_properties'].badges) {
                changes['media_properties'].badges = currentData['media_properties'].badges;
            }
            if (changes.background_properties) {
                changes.background_properties.lang = $scope.page.background.selectedLanguage;
            }

            service.save(($scope.isAvailableForPublish? currentData: changes)).then(function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("global.successfullyPublished");
                        service.load({lang: $scope.page.background.selectedLanguage}).then(function (loadingResponse) {
                            if (loadingResponse.status === 'ok') {
                                update(loadingResponse);
                            }

                        },function (failResponse) {
                            errorHandler(failResponse.message)
                        })
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            );




        };
        /**
         * Delete background icon callback
         */
        $scope.deleteBackground = function deleteBackground() {
            $scope.page.background.image = false;
            $scope.imageToLoad = null;
            $scope.draggedImageDataUrl = $scope.draggedImage  = undefined;
        };

        /**
         * Processing background language change
         */
        $scope.languageChangeHandler = function languageChangeHandler() {
            service.load({lang: $scope.page.background.selectedLanguage}).then(function (loadingResponse) {
                if (loadingResponse.status === 'ok') {
                    initBackgrounds(loadingResponse['background_properties'], $scope.page.background.selectedLanguage);
                }
            },function (failResponse) {
                errorHandler(failResponse.message)
            })
        }
        /**
         * Check is data changed
         * @returns {boolean}
         */
        $scope.isChanged = function isChanged() {
            var changed = $scope.isAvailableForPublish || $scope.publishAllBackgrounds || ($scope.draggedImage && $scope.draggedImage.lastModified) || $scope.imageToLoad || (preloadedProviders && !angular.equals($scope.initialData.grid, $scope.page.grid)) || !angular.equals($scope.initialData.background, $scope.page.background);
            if (!changed) {
                changed = changed || $scope.page.media.isImages !== $scope.initialData.media.isImages;
                if(($scope.page.media.isImages || !preloadedProviders)&& !changed) {
                    changed = changed || !angular.equals($scope.initialData.media.labels, $scope.page.media.labels);
                    if (!changed) {
                        Object.keys($scope.page.media.gameIdImageMap).forEach(function (key) {
                            if(Object.keys($scope.page.media.gameIdImageMap[key]).length > 0){
                                changed = changed || !angular.equals($scope.page.media.gameIdImageMap[key], $scope.initialData.media.gameIdImageMap[key]);
                            }
                        });
                    }

                }
            }

            return changed;
        };

        $scope.getProviderFullName = function getProviderFullName(key) {
            for (var i = 0, length = preloadedProviders.length; i < length; i++) {
                if (preloadedProviders[i].provider === key) {
                    return preloadedProviders[i].providerTitle;
                }
            }
        };
        /**
         * Get game image
         */
        $scope.getGameImage = function getGameImage(game) {
            var image = game.game.icon_3;
            if($scope.removedGameImages[game.gameSkinId]) {
                image = undefined;
            }
            return image;
        }

        $scope.openPreview = function openPreview() {
            var myWindow = $window.open("", "MsgWindow", "width=1000,height=800");
            $templateRequest('views/pageBuilders/liveCasino/preview.html').then(
                function (html) {
                    html = $interpolate(html)($scope);
                    var head = myWindow.document.head || myWindow.document.getElementsByTagName('head')[0];
                    myWindow.document.write(html);
                }
            );
        }

        /**
         * Update live casino background and load games
         * @param data live casino properties
         */
        function update(data) {
            $scope.page.media.gameIdImageMap = {};
            $scope.removedGameImages = {};
            if (($scope.page.media.isImages && $scope.mediaFilters.selectedProviders.length > 0) || !preloadedProviders) {
                $scope.loadGames();
            }
            $scope.imageToLoad = undefined;
            $scope.calledCount = 0;

            $scope.draggedImageDataUrl = $scope.draggedImage = undefined;
            var backgroundProperties = data['background_properties'];
            if (backgroundProperties.image) {
                $scope.page.background.image = backgroundProperties.image;
                $scope.initialBackgroundImage = backgroundProperties.image;
            } else {
                $scope.initialBackgroundImage = undefined;
                $scope.page.background.image = "";
            }
            $scope.publishAllBackgrounds = false;
            $scope.isAvailableForPublish = false;
            $scope.initialData = angular.copy($scope.page);
        }

        /**
         * Filter live casino games
         */
        $scope.filterGames = function filterGames() {
            if ($scope.gamesContainer.filter !== null){
                $scope.gamesContainer.games = allGames.filter(function (item) {
                    return item.game.name.toLowerCase().indexOf($scope.gamesContainer.filter.toLowerCase()) !== -1;
                });
            } else {
                $scope.gamesContainer.games = allGames;
            }
        };

        /**
         *  Compute and return background size property
         */
        $scope.getBackgroundSize = function getBackgroundSize(page) {
            page = page || $scope.page;
            var result = "";
            if (page.background.size.type === 'custom') {
                result = page.background.size.size + page.background.customSizeType;
            } else {
                result =  builderPageDefaults.backgroundSize[page.background.size.type];
            }
            return result;
        };

        function getPosition(page ) {
            page = page || $scope.page;

            var result = "";
            if (page.background.positionCustom) {
                if (page.background.positionHorizontal) {
                    result = page.background.positionHorizontal + page.background.customPositionType;
                }
                if (page.background.positionVertical) {
                    result += ' ' + page.background.positionVertical + page.background.customPositionType;
                }
            } else {
                if (page.background.positionHorizontalRadio) {
                    result = page.background.positionHorizontalRadio;
                }

                if (page.background.positionVerticalRadio) {
                    result += ' ' + page.background.positionVerticalRadio;
                }
            }
            return result;
        }

        function extractPosition(value) {
            var background = $scope.page.background;
            if (value === undefined || value === '') {
                background.positionCustom = true;
                background.customPositionType = 'px';
                background.positionHorizontal = "";
                background.positionVertical = "";
                background.positionHorizontalRadio = "";
                background.positionVerticalRadio = "";

                return;
            }
            if (value.match(/[0-9]/g)) {
                background.positionCustom = true;
                if (value.indexOf('px') > -1) {
                    background.customPositionType = 'px';
                } else if (value.indexOf('%') > -1) {
                    background.customPositionType = '%';
                }
                var values = value.replace(/%/g, "").replace(/px/g, "").split(" ");
                if (values.length === 2) {
                    background.positionHorizontal = values[0];
                    background.positionVertical = values[1];
                } else if (values.length === 1) {
                    background.positionHorizontal = values[0];
                    background.positionVertical = "";
                }
                background.positionHorizontalRadio = "";
                background.positionVerticalRadio = "";

            } else {
                var values = value.split(" ");
                var horizontalMap = {
                    'left': true,
                    'right': true,
                    'center': true,
                };
                var verticalMap = {
                    'top': true,
                    'bottom': true,
                    'center': true
                };
                background.positionHorizontalRadio = horizontalMap[values[0]]? values[0]: 'left';
                background.positionVerticalRadio = (values.length > 1 && verticalMap[values[1]]) ? values[1]: 'top';
                background.positionHorizontal = "";
                background.positionVertical = "";
            }
            background.customPositionType =  background.customPositionType || 'px';
        }

        $scope.openLabelPopup = function openLabelPopup(game) {
            $modal.open({
                templateUrl: "views/pageBuilders/skillGames/gameLabel.html",
                controller: "GamesLabelPopupController",
                resolve: {
                    initialLabel: function () {
                        return  $scope.page.media.labels[game.gameSkinId] || game.badge;
                    }
                }
            }).result.then(function (res) {
                $scope.page.media.labels[game.gameSkinId] = res;
            });

        };
    }



]);
